import { JsonObject, JsonProperty } from "ta-json";

import type { Nullable } from "..";
import { EntityCopyOptionsResource } from "./entity-copy-options-resource";

/**
 * Defines the entity copy options resource.
 */
@JsonObject()
export class RelationCopyOptionResource {
    /**
     * Gets or sets the name of the property.
     */
    @JsonProperty("relation")
    relation: string;

    /**
     * Gets or sets the copy method.
     */
    @JsonProperty("method")
    method: string;

    /**
     * Gets or sets the culture load option.
     */
    @JsonProperty("related_copy_options")
    relatedCopyOptions: Nullable<EntityCopyOptionsResource>;

    constructor(relation: string, method: string, relatedCopyOptions: Nullable<EntityCopyOptionsResource>) {
        this.relation = relation;
        this.method = method;
        this.relatedCopyOptions = relatedCopyOptions ?? null;
    }
}
